export default "__VITE_ASSET__C9z9wDN$__"